// extracted by mini-css-extract-plugin
export default {"tabs":"burger-ingredients_tabs__gJv1+","ingredients":"burger-ingredients_ingredients__s7nFm","ingredient":"burger-ingredients_ingredient__XlBW0"};